'use strict';

wbApp.directive('wbAttendanceStatusEdit',
    function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            scope: {
                status: '=ngModel',
                disabled: '=ngDisabled',
            },
            template:
                "<div class='radio wb-radio'><label><input wb-checkbox-edit ng-model='checkedArr[0]' ng-disabled='disabled' ng-change='onCheckboxClick(0)' ><span>&nbsp;{{'TXT_VAL_PRESENT' | translate}}</span></label></div>" +
                "<div class='radio wb-radio'><label><input wb-checkbox-edit ng-model='checkedArr[1]' ng-disabled='disabled' ng-change='onCheckboxClick(1)' ><span>&nbsp;{{'TXT_VAL_NOT_PRESENT' | translate}}</span></label></div>" +
                "<div class='radio wb-radio'><label><input wb-checkbox-edit ng-model='checkedArr[2]' ng-disabled='disabled' ng-change='onCheckboxClick(2)' ><span>&nbsp;{{'TXT_VAL_EXCUSED' | translate}}</span></label></div>" +
                "<div class='radio wb-radio'><label><input wb-checkbox-edit ng-model='checkedArr[3]' ng-disabled='disabled' ng-change='onCheckboxClick(3)' ><span>&nbsp;{{'TXT_VAL_EXCUSED_NO_COMP' | translate}}</span></label></div>",
            link: function (scope, element, attr, ctrl) {

                scope.checkedArr = [false, false, false, false];

                function fromViewValue(value) {
                    for (var i = 0; i < scope.checkedArr.length; i++) {
                        scope.checkedArr[i] = value === i;
                    }
                }

                function toViewValue() {
                    return scope.checkedArr.indexOf(true);
                }

                scope.onCheckboxClick = function (idx) {
                    for (var i = 0; i < scope.checkedArr.length; i++) {
                        scope.checkedArr[i] = idx === i;
                    }
                    ctrl.$setViewValue(idx);
                   // $event.preventDefault();
                }

                ctrl.$render = function () {
                    scope.spanChecked = fromViewValue(ctrl.$viewValue);
                };
            }
        }
    });
